import { InvoiceLineModel } from "./invoiceline.model";
import { QRCodeModel } from "../../qr/qrcode.model";
import { consts } from "../../../consts";

export class DeliverynoteModel {
  uid: string;
  invoiceLines: Array<InvoiceLineModel>;
  activityUid: string;
  published: boolean;
  contabilized: boolean;
  issuerName: string;
  issuerVatNumber: string;
  issuerAddress: string;
  issuerLocation: string;
  issuerPostalCode: string;
  issuerState: string;
  issuerCountry: string;
  receiverUid: string;
  receiverName: string;
  centerUid: string;
  preInvoiceNumber: string;
  invoiceNumber: string;
  invoiceRelease: Date;
  invoiceExpiration: Date;
  received: Date;
  sendedMail: Date;
  paided: Date;
  returned: Date;
  recurrentNumber: string;
  recurrentFrequency: string;
  recurrentStart: Date;
  isNative: boolean;
  isReceptor: boolean;
  base: number;
  total: number;
  typePay: string;
  typePayBankAccount: string;
  expenseAccount: string;
  entranceAccount: string;
  rectifying: boolean;
  comments: string;
  qrcode: QRCodeModel;
  qrstring: string;
  publish: boolean;
  preinvoicePublished: boolean;
  PreinvoiceToInvoiceNumber: string;
  isDeliveryNote: boolean;
  isSelected: boolean;
  isInvoice: boolean;
  fiscalYear: number;
  convertedToInvoice: Date;
  numberKilometers: number;
  efectivoId: string;
  partnersId: number;
  projectUid?: string;
  useDeliverAddress: boolean;
  noConditions: boolean;
  conditions: boolean;
  constructor() {
    this.noConditions = true;
  }
}
